module.exports = __webpack_public_path__ + "img/project-2-banner.f93f8a4e.png";